<template>
  <v-row>
    <v-col cols="12">
      <h1>Главная страница</h1>
    </v-col>
    <v-col cols="12">
    <v-tabs v-model="tab">
      <v-tab>Сайт</v-tab>
      <v-tab>Приложение Новинки</v-tab>
      <v-tab>Приложение Акции</v-tab>
      <v-tab>Фон на Главной</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item :eager="true">
        <site></site>
      </v-tab-item>
      <v-tab-item :eager="true">
        <app-new></app-new>
      </v-tab-item>
      <v-tab-item :eager="true">
        <app-sale></app-sale>
      </v-tab-item>
      <v-tab-item :eager="true">
        <PictureBG></PictureBG>
      </v-tab-item>
    </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
import Site from './Site'
import AppNew from './AppNew'
import AppSale from './AppSale'
import PictureBG from "@/views/Home/PictureBG";
export default {
  name: 'HomeIndex',
  components: {Site, AppNew, AppSale, PictureBG },
  data: () => ({
      tab: 0
  }),
  mounted() {



  },
  watch: {},
  methods: {

  },
}
</script>

<style lang="scss" scoped>
  .page__grab-icon{
    &:hover{
      cursor: move;
    }
  }
</style>
